//
export default [
    'g_originator_user.hr_employee',
    'g_authorizer_user.hr_employee',
    'pch_detail_purchase_orders.wh_product',
    'pch_payment_condition',
    'pch_provider',
    'pch_provider_branch_offices',
    'pch_purchase_order_state',
    'wh_orderers.pch_provider',
    'wh_orderers.pch_provider_branch_offices',
    'wh_orderers.g_supervisor_user',
    'pch_purchase_order_has_invoice_numbers.pch_purchase_invoice',
    //'wh_product_receptions',
    'wh_warehouse.g_branch_office.g_commune',
    'wh_warehouse_reception.g_branch_office.g_commune',
]
